export const validMPIDProjectStatusList = [
  "Defined", 
  "Planned",
  "In Process",
  "In Execution",
  "Complete"
]